// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zxcm","clinicsSelect":"styles_clinicsSelect__1LfmA"};